import semver from 'semver';

export const hasAnUpdateAvailable = (latestVersion, currentVersion) => {
  if (!semver.valid(latestVersion)) {
    return false;
  }
  semver.lt(currentVersion, latestVersion);
  return false;
};
